// src/components/Profile/AddressModal.jsx
import React, { useState } from 'react';
import { canadianProvinces } from '../../utils/profileHelpers';

export default function AddressModal({ address, onSave, onClose }) {
  const [formData, setFormData] = useState({
    addressLabel: address?.address_data?.addressLabel || '',
    fullName: address?.address_data?.fullName || '',
    company: address?.address_data?.company || '',
    streetAddress: address?.address_data?.streetAddress || '',
    city: address?.address_data?.city || '',
    province: address?.address_data?.province || '',
    postalCode: address?.address_data?.postalCode || '',
    phone: address?.address_data?.phone || '',
    email: address?.address_data?.email || '',
    deliveryNotes: address?.address_data?.deliveryNotes || ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const required = ['addressLabel', 'fullName', 'streetAddress', 'city', 'province', 'postalCode', 'phone', 'email'];
    const missing = required.filter(field => !formData[field]);

    if (missing.length > 0) {
      alert('Please fill all required fields');
      return;
    }

    onSave(formData);
  };

  const inputStyle = {
    padding: '12px 16px',
    border: '2px solid #e5e7eb',
    borderRadius: '8px',
    fontSize: '14px',
    fontFamily: 'inherit',
    width: '100%',
    boxSizing: 'border-box',
    transition: 'all 0.3s ease'
  };

  const labelStyle = {
    fontSize: '14px',
    fontWeight: 600,
    color: '#1f2937'
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px',
        overflowY: 'auto'
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '16px',
          maxWidth: '900px',
          width: '100%',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 20px 50px rgba(0, 0, 0, 0.3)',
          margin: 'auto'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          padding: '24px 30px',
          borderBottom: '1px solid #e5e7eb',
          flexShrink: 0,
          background: 'white',
          borderRadius: '16px 16px 0 0'
        }}>
          <h3 style={{ fontSize: '22px', fontWeight: 700, margin: 0, color: '#1f2937' }}>
            {address ? 'Edit Address' : 'Add New Address'}
          </h3>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '28px',
              cursor: 'pointer',
              color: '#6b7280',
              padding: 0,
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = '#f9fafb';
              e.currentTarget.style.color = '#1f2937';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = 'none';
              e.currentTarget.style.color = '#6b7280';
            }}
          >
            <i className="ph ph-x"></i>
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
          {/* Body - Scrollable */}
          <div style={{
            padding: '24px 30px',
            overflowY: 'auto',
            flex: 1,
            minHeight: 0
          }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: window.innerWidth > 1024 ? 'repeat(3, 1fr)' : window.innerWidth > 768 ? 'repeat(2, 1fr)' : '1fr',
              gap: '16px',
              paddingBottom: '20px'
            }}>
              {/* Address Label */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={labelStyle}>Address Label *</label>
                <input
                  type="text"
                  name="addressLabel"
                  value={formData.addressLabel}
                  onChange={handleChange}
                  placeholder="e.g., Home, Office"
                  required
                  style={inputStyle}
                />
              </div>

              {/* Full Name */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={labelStyle}>Full Name *</label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                />
              </div>

              {/* Company */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={labelStyle}>Company</label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>

              {/* Street Address */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                gridColumn: window.innerWidth > 1024 ? 'span 3' : window.innerWidth > 768 ? 'span 2' : 'span 1'
              }}>
                <label style={labelStyle}>Street Address *</label>
                <input
                  type="text"
                  name="streetAddress"
                  value={formData.streetAddress}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                />
              </div>

              {/* City */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={labelStyle}>City *</label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                />
              </div>

              {/* Province */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={labelStyle}>Province *</label>
                <select
                  name="province"
                  value={formData.province}
                  onChange={handleChange}
                  required
                  style={{...inputStyle, cursor: 'pointer'}}
                >
                  {canadianProvinces.map(prov => (
                    <option key={prov.value} value={prov.value}>{prov.label}</option>
                  ))}
                </select>
              </div>

              {/* Postal Code */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={labelStyle}>Postal Code *</label>
                <input
                  type="text"
                  name="postalCode"
                  value={formData.postalCode}
                  onChange={handleChange}
                  pattern="[A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9]"
                  title="Format: A1A 1A1"
                  placeholder="A1A 1A1"
                  required
                  style={inputStyle}
                />
              </div>

              {/* Phone */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={labelStyle}>Phone *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                />
              </div>

              {/* Email */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={labelStyle}>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                />
              </div>

              {/* Delivery Notes */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                gridColumn: window.innerWidth > 1024 ? 'span 3' : window.innerWidth > 768 ? 'span 2' : 'span 1'
              }}>
                <label style={labelStyle}>Delivery Instructions (Optional)</label>
                <textarea
                  name="deliveryNotes"
                  value={formData.deliveryNotes}
                  onChange={handleChange}
                  rows="3"
                  style={{
                    ...inputStyle,
                    resize: 'vertical',
                    minHeight: '80px'
                  }}
                />
              </div>
            </div>
          </div>

          {/* Footer - Sticky */}
          <div style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: '20px 30px',
            borderTop: '1px solid #e5e7eb',
            flexShrink: 0,
            background: 'white',
            borderRadius: '0 0 16px 16px',
            position: 'sticky',
            bottom: 0
          }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: '12px 24px',
                borderRadius: '8px',
                fontWeight: 600,
                fontSize: '15px',
                cursor: 'pointer',
                border: '2px solid #8b5cf6',
                background: 'white',
                color: '#8b5cf6',
                minWidth: '100px',
                minHeight: '44px',
                transition: 'all 0.3s ease'
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                padding: '12px 24px',
                borderRadius: '8px',
                fontWeight: 600,
                fontSize: '15px',
                cursor: 'pointer',
                border: 'none',
                background: '#8b5cf6',
                color: 'white',
                minWidth: '150px',
                minHeight: '44px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'all 0.3s ease'
              }}
            >
              <i className="ph ph-floppy-disk" style={{ fontSize: '18px' }}></i>
              {address ? 'Update Address' : 'Save Address'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}